import React from 'react';
import useSetting from '@src/hooks/useSetting';
import { useConnect } from 'redux-bundler-hook';
import getThumbnailsFromBricks from '@src/utils/getThumbnailsFromBricks';
import defaultImage from '@src/assets/images/kinto-soc-media.jpg';
import { getLocaleForLanguage } from '@src/utils/countries-lookup';
import { findEditableByName } from '@src/utils/BrickResolver';

export default function Seo({ title = '', seoTitle = null, location = {}, pageContextData }) {
	const defaultLanguage = process.env.GATSBY_DEFAULT_LANGUAGE || 'sv'; //TODO: defaultlanguage does not exist change to lang= instead with the current language!
	const siteUrl = process.env.GATSBY_SITE_URL;
	const { language } = useConnect('selectLanguage');
	const getSetting = useSetting();

	const cdnHost = getSetting('CDNHost', '');

	const hideFromSearchEngines = getSetting('hide_from_search_engines', false);
	const soc_media_image_setting = getSetting('soc_media_picture');
	const defaultSeoTitle = getSetting('seo_default_title');
	const defaultSeoDescription = getSetting('seo_default_description');
	let description = defaultSeoDescription;
	let finalSeoImage = soc_media_image_setting || defaultImage;
	let pageUrl = siteUrl;
	let nonIndexable = false;

	const locale = getLocaleForLanguage(language);

	if (pageContextData) {
		if (pageContextData.data == undefined || pageContextData?.apiPageUrl.endsWith('-custom/')) {
			//Custom page mark as nonIndexable and ignore other params
			nonIndexable = true;
		} else {
			description = pageContextData.description;
			title = pageContextData.title;
			seoTitle = pageContextData.seoTitle;
			pageUrl = `${siteUrl}${pageContextData.apiPageUrl}`;

			const nonIndexableEditable = findEditableByName(pageContextData.data.editables, 'nonIndexable');
			if (nonIndexableEditable) {
				nonIndexable = nonIndexableEditable.value;
			}

			const thumbImages = getThumbnailsFromBricks(pageContextData.data, 'og-image');
			if (thumbImages && thumbImages.length > 0) {
				const imgPath = thumbImages[0].xlarge || thumbImages[0].large || thumbImages[0].defaultImage;
				if (imgPath) {
					finalSeoImage = `${cdnHost}${imgPath}`;
				}
			}
		}
	}

	if (location.href) {
		pageUrl = location.href;
	}

	const finalTitle = title || seoTitle || defaultSeoTitle;
	const finalDescription = description || defaultSeoDescription;

	return (
		<>
			<title id="">{finalTitle}</title>
			<meta name="description" content={finalDescription} />
			<meta property="og:title" content={finalTitle} />
			<meta property="og:description" content={finalDescription} />
			<meta property="og:type" content="website" />
			<meta property="og:image" content={finalSeoImage} />
			<meta property="og:url" content={pageUrl} />
			<meta property="og:locale" content={locale} />
			{(hideFromSearchEngines || nonIndexable) && <meta name="robots" content="noindex, nofollow" />}
		</>
	);
}
